import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import './number-input.css';
class NumberInput extends Component {
  static propTypes = {
    disabled: PropTypes.bool
  }

  constructor(props) {
    super(props);

    this.id = uuidv4();

    this.state = { value: 0 };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ value: Number(nextProps.value) });
  }

  handleChange(e) {
    if (Number(e.target.value) <= this.props.max) {
      if (Number(e.target.value) >= this.props.min) {
        this.setState({ value: Number(e.target.value) });
      } else {
        this.setState({ value: this.props.min });
      }
    }
  }

  onKeyup(e) {
    if (/\D/g.test(e.target.value)) {
      this.setState({ value: Number(e.target.value.replace(/\D/g, '')) });
    }
  }

  render() {
    return <div className={this.props.disabled ? 'inputText disabled' : 'inputText'} style={this.props.style}>
      <input value={this.state.value}
        className='form-control-input'
        onKeyUp={this.onKeyup.bind(this)}
        onChange={this.handleChange.bind(this)}
        disabled={this.props.disabled}
        type='text' />
    </div>;
  }
}

NumberInput.propTypes = {
  value: PropTypes.any,
  className: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  style: PropTypes.object
};

export default NumberInput;



// WEBPACK FOOTER //
// ./src/components/number-input/index.js